/*jslint browser: true */
'use strict';
var extend = require('raptor-util/extend');

var managerProvider = require('./manager-provider-browser');
var manager = managerProvider.getDefault();
exports.getContentManager = managerProvider.getDefault;
exports.t = function (bundle, path, data, context) {
if (window.$i18n) {
    return manager
        .getBundle(bundle)
        .getText(path, data, context);
}

  // If content is available then we will just return a string that can be
  // used for tests, storybook, etc.
  return `i18n.t("${bundle}", "${path}"${data ? `, ${JSON.stringify(data)}` : ''})`;
};

extend(exports, require('./legacy'));
